import _ from "lodash";
import { Events } from "../Events/Events";

export class DepartmentPersonnelCopiesService {
    copies = [];
    company = {};

    Events = new Events();

    constructor({
        SerieHttpGateway,
        AvailableHttpGateway,
        CompanyHttpGateway
    } = {}) {
        this.SerieHttpGateway = SerieHttpGateway;
        this.AvailableHttpGateway = AvailableHttpGateway;
        this.CompanyHttpGateway = CompanyHttpGateway;
    }

    setCompany({ company }) {
        this.company = company;
    }

    init({ company, scenarioId, series } = {}) {
        this.company = company;
        const copiesList = this.getCopiesConfigs({
            scenarioId,
            series
        });

        const copies = {
            list: copiesList,
            isAnyCopyActive: this.isAnyCopyActive({ series }),
            isAnyCopyAvailable: this.isAnyCopyAvailable({
                scenarioId
            })
        };

        this.copies = copies;
    }

    getCopies() {
        return this.copies;
    }

    getCopiesConfigs({ scenarioId, series } = {}) {
        const copies = [
            {
                name: "Faturamento do Fiscal",
                description:
                    "Copiar o faturamento da edição ou planilha para pessoal",
                from: "tax",
                active: this.isCopyActiveBySource({ series, source: "tax" }),
                preference: "preferences.copyTaxPersonnel",
                available: this._isCopyAvailable({
                    source: "tax",
                    scenarioId
                })
            },
            {
                name: "Faturamento do PGDAS",
                description:
                    "Copiar faturamento do PGDAS do Fiscal para pessoal",
                from: "simplesNacional",
                active: this.isCopyActiveBySource({
                    series,
                    source: "simplesNacional"
                }),
                preference: "preferences.copyPGDASPersonnel",
                available: this._isCopyAvailable({
                    source: "simplesNacional",
                    scenarioId
                })
            },
            {
                name: "Faturamento e Total da Folha do balancete",
                description:
                    "Copiar e sincroniza o Faturamento e o Total da Folha",
                from: "accounting",
                preference: "preferences.copyBalanceSheetToPersonnel",
                active: this.isCopyActiveBySource({
                    series,
                    source: "accounting"
                }),
                available: this._isCopyAvailable({
                    source: "accounting",
                    scenarioId
                })
            }
        ];

        return copies;
    }

    _isCopyAvailable({ scenarioId, source } = {}) {
        const companyId = this._getCompanyId();
        const available = this.AvailableHttpGateway.get({
            companyId,
            scenarioId,
            source
        });

        return _.get(available, "length") ? true : false;
    }

    isCopyActiveBySource({ series, source } = {}) {
        if (!series || !source) return false;

        if (!["simplesNacional", "tax", "accounting"].includes(source))
            return false;

        const syncAccounting = series.filter((serie) => {
            return (
                serie.props.metadata.sync &&
                serie.props.metadata.sourceSync === source
            );
        });

        return syncAccounting.length ? true : false;
    }

    isAnyCopyActive({ series } = {}) {
        return (
            this.isCopyActiveBySource({ series, source: "tax" }) ||
            this.isCopyActiveBySource({ series, source: "simplesNacional" }) ||
            this.isCopyActiveBySource({ series, source: "accounting" })
        );
    }

    isAnyCopyAvailable({ scenarioId } = {}) {
        const taxCopy = this._isCopyAvailable({
            source: "tax",
            scenarioId
        });

        const simplesNacionalCopy = this._isCopyAvailable({
            source: "simplesNacional",
            scenarioId
        });

        const accountingCopy = this._isCopyAvailable({
            source: "accounting",
            scenarioId
        });

        return taxCopy || simplesNacionalCopy || accountingCopy;
    }

    async _updateCompanyPreferencesFlag({ preference, flag }) {
        const companyId = this._getCompanyId();
        this.company.setCopiePreference(preference, flag);
        return await this.CompanyHttpGateway.updateFields(
            this.company.props.accountingId,
            companyId,
            {
                preferences: this.company.props.preferences
            }
        );
    }

    async syncCopy({ from, preference } = {}) {
        const companyId = this._getCompanyId();
        const response = await this.SerieHttpGateway.copySerieToAnotherSource({
            companyId,
            sources: { to: "personnel", from }
        });

        this.Events.setParamns({ companyId });
        this.Events.send(`Copiar.${from}.Pessoal`);

        if (response && preference)
            await this._updateCompanyPreferencesFlag({
                preference,
                flag: true
            });

        return true;
    }

    async unsyncCopy({ preference, from } = {}) {
        const companyId = this._getCompanyId();

        const series = await this.SerieHttpGateway.getAccountsPlan({
            companyIds: companyId,
            source: "personnel",
            origin: "editMode"
        });

        const seriesSync = series.filter((serie) => serie.syncReferenceId);

        if (seriesSync.length) {
            const seriesModifier = seriesSync.map((serie) => ({
                _id: serie._id,
                unsetSync: true
            }));
            const response = await this.SerieHttpGateway.save(seriesModifier);

            this.Events.setParamns({ companyId });
            this.Events.send(`Copia.Desativar.${from}.Pessoal`);

            if (response)
                await this._updateCompanyPreferencesFlag({
                    preference,
                    flag: false
                });
        }
        return true;
    }

    getCopyActive() {
        if (!this.copies.length) return {};

        const copy = this.copies.find((c) => c.active);

        if (!copy) return {};

        return copy;
    }

    _getCompanyId() {
        return this.company.props._id;
    }
}
